<template>
  <div>
    <div class="header">
      <a :href="logoLink">
        <img :src="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/static/img/register/logo.svg' : '/static/img/register/KKBrand_Logo.png'">
      </a>
    </div>
    <div class="verify_email">
      <div class="container">
        <div :class="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'detail_section_nuts' : 'detail_section'">
          <div class="detail_title">
            <h1>{{ $t('register.LAB_VERIFY_EMAIL')}}</h1>
          </div>
          <div class="email_icon">
            <img :src="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/static/img/register/email/email_verify_nuts.png' : '/static/img/register/email/email_verify.png'">
            </div>
          <div class="detail_content">
            <div class="email">
              <i18n class="text" path="register.LAB_VERIFY_EMAIL_ADDRESS" tag="span">
                <span place="email address">
                  {{ email }}
                </span>
              </i18n>
            </div>
            <div class="description">
              <p>
               {{ $t('register.LAB_VERIFY_TIPS') }}
              </p>
            </div>
          </div>
        </div>
        <div :class="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'button_section_nuts' : 'button_section'">
          <div class="send_button" :class="{'disabled': disableClass}" @click="toRegister(2)">
            <p>{{ $t('register.LAB_VERIFY_RESEND') }} {{ remainingTime == '60' ? '' : `${remainingTime}s` }} </p>
          </div>
          <div class="legal" @click="showLegalDialog()">
            <a>{{ $t('register.LAB_VERIFY_PROTECT') }}</a>
          </div>
          <van-dialog
            v-model="dialogVisible"
            class="legal_dialog"
            get-container="body"
            :show-confirm-button="false"
            :close-on-click-overlay="true"
            width="30%"
          >
            <div class="content">
              <img class="close_button" @click="dialogVisible = false" :src="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/static/img/register/email/close_button_nuts.png' : '/static/img/register/email/close_button.png'">
              <img :src="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? `/static/img/register/email/nuts/info_protection_${lang === 'ru' ? 'ru' : 'en'}.png?t=20250205` : ('/static/img/register/email/'+ currentType +'/info_protection_' + lang + '.png?t=20230410')">
            </div>
          </van-dialog>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="loading"
      class="loading_dialog"
      get-container="body"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      width="30%"
    >
      <van-loading size="48px" color="#FFFFFF"/>
    </van-dialog>
  </div>
</template>

<script>
import { toBury } from '@/configs/userStatsTrack'
import { getErrorMsg } from '@/configs/register'
import { sendRegister } from '@/api/official'
import siteType from '@/configs/siteType'
import { logoLinkMixin } from '../mixin/logoLink'

export default {
  name: 'verification_email',
  mixins: [logoLinkMixin],
  data () {
    return {
      email: '',
      lang: '',
      is_invitecode: '',
      clubId: '',
      hostId: '',
      dialogVisible: false,
      currentType: '',
      remainingTime: 59,
      intervalId: null,
      disableClass : false,
      loading: false,
      siteType,
    }
  },
  // calculate the start time of the timer
  beforeRouteEnter(to, from, next) {
    const startTime = parseInt(localStorage.getItem("startTime"))
    // if the start time is less than 30 minutes, then start the timer
    if (startTime && Date.now() - startTime < 30 * 60 * 1000) {
      next((vm) => {
        vm.startTimer(startTime)
      })
    } else { // create timer from now
      next((vm) => {
        vm.startTimer(Date.now())
      })
    }
  },
  // clear the timer when leaving the page
  beforeRouteLeave(to, from, next) {
    if (this.intervalId) {
    clearInterval(this.intervalId)
  }
    localStorage.removeItem("startTime")
    next()
  },
  created() {
    // early to get initial value from router query
    this.email = this.$route.query.email || JSON.parse(localStorage.getItem('registerParams')).username || ''
    this.lang = this.$route.query.lang || this.$i18n.locale,
    this.is_invitecode = this.$route.query.is_invitecode || false
    this.clubId = this.$route.query.clubId || ''
    this.hostId = this.$route.query.hostId || ''
    this.platform = this.$route.query.platform || ''
    this.track(1) // f2 = 1(link register verify)
  },
  mounted() {
    this.currentType =  JSON.parse(localStorage.getItem('legal')).currentType 
    localStorage.setItem("startTime", Date.now())
    this.resendCountDown()
  },
  methods: {
    showLegalDialog () {
      this.dialogVisible = true
    },
    resendCountDown() {
      this.disableClass = true
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--
        } else {
          clearInterval(this.timer)
          this.disableClass = false
          this.remainingTime = 60
        }
      }, 1000)
    },
    startTimer(startTime) {
      this.intervalId = setInterval(() => {
        const elapsedTime = Date.now() - startTime
        if (elapsedTime >= 30 * 60 * 1000) {
          clearInterval(this.intervalId)
          this.$router.push({path: '/'})
          return
        }
        localStorage.setItem("startTime", startTime)
      }, 1000)
    },
    track(f2) {
      let buryType = ''
      // if is_invitecode is string, then convert it to boolean
      if(typeof this.is_invitecode === 'string') {
        this.is_invitecode = !!this.is_invitecode
      }
      if(f2 == 1) {
        buryType = !this.is_invitecode ? 'LinkRegisterVerify' : 'IniviteLinkRegisterVerify'
      } else {
        buryType = !this.is_invitecode ? 'VerifyResendMail' : 'IniviteLinkVerifyResendMail'
      }
      const f3 = !this.is_invitecode ? 1 : 2
      const f4 = this.hostId ? this.hostId : 0
      toBury(this, buryType, 802, f2, f3, f4, 1, this.platform, this.clubId)
    },
    toRegister(f2) {
      const params = this.$store.state.registerParams
      params.is_resend = 1 // 0: first time, 1: resend
      this.resendCountDown()
      if(f2 === 2) {
        this.loading = true
      }
      sendRegister(params)
      .then((res) => {
        this.loading = false
        if (res.code == 0) {
          // decide whether to click resend button
          if(f2 === 2) {
            this.track(f2)
          }
        } else {
          const msg = getErrorMsg(res.code)
          this.$toast({
            message: this.$t(msg),
            className: 'register_toast'
          })
        }
      })
      .catch((err) => {
        console.log(err)
        this.$toast({
          message: this.$t('register.LAB_HISTORY_SHARE_ERROR'),
          className: 'register_toast'
        })
      })
    }
  }
}
</script>
<style lang="less">
body,
#default-layout {
  background-color: #151515;
  height: 100%;
}
html,
body,
#default-layout {
  height: 100%;
}

</style>
<style lang="less" scoped>
.header{
  height: 70px;
  background-color: #000000;
  img {
    position: absolute;
    left: 50px;
    top: 15px;
    width: 170px;
    height: auto;
  }
}
.verify_email {
  width: 100%;
  height: 100%;
  background: #151515;
  position: relative;
  z-index: 0;
}
.container {
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.detail_section{
  .detail_title{
    h1{
      font-size:  32px;
      color: #ffffff;
      text-align: center;
      margin-top: 90px;
    }
  }
  .email_icon{
    text-align: center;
    img{
      width: 100%;
      height: 400px;
      max-width: 400px;
      margin-top: 32px;
    }
  }
  .detail_content{
    max-width: 620px;
    margin: 0 auto;
    .email{
      text-align: center;
      font-size:  30px;
      color: #ffffff;
      margin-top: 100px;
      span{
        color:#1F995C;
      }
      .text{
        color: #ffffff;
      }
    }
    .description{
      text-align: center;
      font-size:  20px;
      color: #ffffff;
      margin-top: 50px;
      line-height: 34px;
    }
  }
}
.detail_section_nuts{
  .detail_title{
    h1{
      font-size:  32px;
      color: #ffffff;
      text-align: center;
      margin-top: 90px;
    }
  }
  .email_icon{
    text-align: center;
    img{
      width: 100%;
      height: 400px;
      max-width: 400px;
      margin-top: 32px;
    }
  }
  .detail_content{
    max-width: 620px;
    margin: 0 auto;
    .email{
      text-align: center;
      font-size:  30px;
      color: #ffffff;
      margin-top: 100px;
      span{
        color:rgba(195, 173, 130, 1);
      }
      .text{
        color: #ffffff;
      }
    }
    .description{
      text-align: center;
      font-size:  20px;
      color: #ffffff;
      margin-top: 50px;
      line-height: 34px;
    }
  }
}
.button_section {
  text-align: center;
  width: 100%;
  height: 100%;
  margin-top: 150px;
  position: relative;
  .send_button {
    width: 400px;
    height: 100px;
    background-image: url('/static/img/register/btn_common_1_n.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    margin: 20px auto 5px auto;
    cursor: pointer;
    p {
      font-size: 30px;
      margin: 20px auto;
      line-height: 100px;
      text-align: center;
      color: #ffffff;
    }
  }
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  .legal {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 20px auto;
    a {
      font-size: 24px;
      text-decoration: underline !important;
      color: #33FF99;
      cursor: pointer;
    }
  }
}
.button_section_nuts {
  text-align: center;
  width: 100%;
  height: 100%;
  margin-top: 150px;
  position: relative;
  .send_button {
    width: 400px;
    height: 100px;
    border: 1.5px solid;
    border-image-source: linear-gradient(0deg, #EFD5AC, #EFD5AC),
    radial-gradient(127.2% 100% at 50% 0%, #FFF7E1 0%, rgba(255, 247, 225, 0.476611) 52.45%, rgba(255, 247, 225, 0) 100%);
    background: linear-gradient(360deg, #9B8155 15%, #CBAF7E 55.5%, #F3E8A8 100%),
    linear-gradient(157.88deg, rgba(255, 255, 255, 0.8) -3.55%, rgba(255, 255, 255, 0) 49.43%);
    border-radius: 10px;
    margin: 20px auto 5px auto;
    cursor: pointer;
    p {
      font-size: 30px;
      line-height: 100px;
      text-align: center;
      color: #ffffff;
    }
  }
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  .legal {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 20px auto;
    a {
      font-size: 24px;
      text-decoration: underline !important;
      color: rgba(195, 173, 130, 1);
      cursor: pointer;
    }
  }
}
.legal_dialog{
  background-color: transparent;
  .content {
    .close_button {
      position: absolute;
      top: -5px;
      right: 10px;
      width: 100px;
      height: 100px;
      background-color: transparent;
    }
    img {
      width: 100%;
      height: 100%
    }
  }
}
.loading_dialog {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;
}
</style>
